import React, {Component} from 'react';

import {autobind} from 'core-decorators';
import {motion} from 'framer-motion';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import styled from 'styled-components';

import AnimationData from 'Frontend/assets/images/search';
import {wait} from 'Frontend/utils/helpers';

/**
 * SearchDecoration
 *
 * @property {*} prop Prop comment.
 *
 * @class SearchDecoration
 * @extends {Component}
 */
class SearchDecoration extends Component {
    static propTypes = {onSearchComplete: PropTypes.func}

    static defaultProps = {onSearchComplete: null}

    /**
     * Creates an instance of SearchDecoration.
     *
     * @param {Object} props Component props.
     * @memberof SearchDecoration
     */
    constructor(props) {
        super(props);

        this.state = {step: 'step1'};
    }

    /**
     * Component did mount
     *
     * @memberof SearchDecoration
     */
    componentDidMount() {
        this.handleNextStep();
    }

    /**
     * Handle Next Step
     *
     * @memberof SearchDecoration
     */
    @autobind
    async handleNextStep() {
        const {onSearchComplete} = this.props;
        const {step} = this.state;

        // eslint-disable-next-line @nfq/no-magic-numbers
        await wait(3000);

        if (onSearchComplete) {
            onSearchComplete();
        } else if (step === 'step1') {
            this.handleNextStep();
            this.setState({step: 'step2'});
        }
    }

    /**
     * Renders the Component.
     *
     * @returns {JSX} Component.
     * @memberof SearchDecoration
     */
    render() {
        return (
            <SearchDecorationElement layoutId="search-decoration">
                <ElementContainer>
                    <LottieContainer>
                        <Lottie
                            options={{
                                animationData: AnimationData,
                                autoloadSegments: false,
                                autoplay: true,
                                loop: false,
                                rendererSettings: {preserveAspectRatio: 'xMidYMid meet'}
                            }}
                        />
                    </LottieContainer>
                </ElementContainer>
            </SearchDecorationElement>
        );
    }
}

export default SearchDecoration;

const LottieContainer = styled.div`
    max-width: 500px;
    padding: 20px;
`;

const ElementContainer = styled.div`
    align-items: center;
    background: #FAF6F4;
    clip-path: polygon(
        0% calc(100% - 86px),
        20px 50%,
        0% 86px,
        100% 0%,
        100% 100%
    );
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
    max-width: 1280px;
    width: 100%;
`;

const SearchDecorationElement = styled(motion.div)`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
`;